import {
	ReviewSectionScoreChart, ReviewTotalScoreChart, TestProgressChart
} from "../../lib/chart";
import OverviewScoreChart from "../../lib/chart/overviewscore";
import {
	AttemptId, ProductId, QuizId, Serializer
} from "../../model/datasource";
import OverviewSummaryTable from "../../lib/overviewsummary";

export class ChartFrontend<P extends ProductId, A extends AttemptId, Z extends QuizId> {
	productIdSerializer: Serializer<P>;

	constructor(product: Serializer<P>) {
		this.productIdSerializer = product;
	}

	getReviewTotalScoreChart(): ReviewTotalScoreChart {
		return new ReviewTotalScoreChart(
			null, null,
			100, 20, 0
		);
	};

	getReviewSectionScoreChart(): ReviewSectionScoreChart {
		return new ReviewSectionScoreChart(
			null, null,
			200, 36,
			0, 120, 20, 5
		);
	};

	getOverviewScoreChart<A, Z>(): OverviewScoreChart<A, Z> {
		return new OverviewScoreChart<A, Z>(
			null, null,
			50, 50, 2
		);
	};

	getTestProgressChart(): TestProgressChart {
		return new TestProgressChart(
			null,
			100, 20, 0
		);
	};

	getOverviewSummaryTable(jQuery: JQueryStatic): OverviewSummaryTable<P> {
		return new OverviewSummaryTable(
			jQuery,
			this.productIdSerializer
		);
	}
}